import React from "react";
import Todo from "./Todo";

function TodoPage() {
  return (
    <div className="App" style={{marginTop: "15%"}}>
      <h1>Todo List App</h1>
      <Todo />
    </div>
  );
}

export default TodoPage;
